import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Ads Conversion Labels - Replace with actual labels from Google Ads
const CONVERSION_LABELS = {
  SERVICE_REQUEST: 'service_request', // Servis talebi oluşturma - PRIMARY
  PHONE_CALL: 'phone_call', // Telefon araması - PRIMARY
  WHATSAPP_CLICK: 'whatsapp_click', // WhatsApp tıklama
  FORM_SUBMIT: 'form_submit', // Form gönderimi
  SIGNUP: 'signup', // Kayıt olma
  LOGIN: 'login', // Giriş yapma
  USTA_SIGNUP: 'usta_signup', // Usta kayıt - PRIMARY
};

// Track conversions
export const trackConversion = (conversionType, value = 1.0, additionalData = {}) => {
  // Google Ads conversion
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': `AW-712842384/${conversionType}`,
      'value': value,
      'currency': 'TRY',
      ...additionalData
    });
  }
  
  // Also track in dataLayer for GTM
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      'event': conversionType,
      'conversionValue': value,
      ...additionalData
    });
  }
  
  console.log(`📊 Conversion tracked: ${conversionType}`, { value, ...additionalData });
};

// Enhanced Conversion with user data (for better attribution)
export const trackEnhancedConversion = (conversionType, userData = {}, value = 1.0) => {
  if (typeof window.gtag !== 'undefined') {
    // Set user data for enhanced conversions (automatically hashed by gtag)
    window.gtag('set', 'user_data', {
      'email': userData.email || undefined,
      'phone_number': userData.phone ? '+90' + userData.phone.replace(/\D/g, '') : undefined,
      'address': {
        'city': userData.city || undefined,
        'region': userData.district || undefined,
        'country': 'TR'
      }
    });
    
    // Track conversion
    window.gtag('event', 'conversion', {
      'send_to': `AW-712842384/${conversionType}`,
      'value': value,
      'currency': 'TRY'
    });
  }
  
  console.log(`📊 Enhanced conversion tracked: ${conversionType}`, { userData, value });
};

// Remarketing event tracking
export const trackRemarketingEvent = (eventName, params = {}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, {
      'send_to': 'AW-712842384',
      ...params
    });
  }
  
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      'event': eventName,
      ...params
    });
  }
};

// Track service request conversion (PRIMARY)
export const trackServiceRequest = (category, estimatedPrice, userData = {}) => {
  // Enhanced conversion with user data
  if (userData.phone || userData.city) {
    trackEnhancedConversion(CONVERSION_LABELS.SERVICE_REQUEST, userData, estimatedPrice || 500);
  } else {
    trackConversion(CONVERSION_LABELS.SERVICE_REQUEST, estimatedPrice || 500, {
      'service_category': category,
      'estimated_price': estimatedPrice
    });
  }
  
  // Remarketing: add to service requesters audience
  trackRemarketingEvent('generate_lead', {
    'value': estimatedPrice || 500,
    'currency': 'TRY',
    'service_category': category
  });
};

// Track phone call click (PRIMARY)
export const trackPhoneCall = () => {
  trackConversion(CONVERSION_LABELS.PHONE_CALL, 50);
  trackRemarketingEvent('contact', { 'method': 'phone' });
};

// Track WhatsApp click
export const trackWhatsAppClick = () => {
  trackConversion(CONVERSION_LABELS.WHATSAPP_CLICK, 30);
  trackRemarketingEvent('contact', { 'method': 'whatsapp' });
};

// Track form submission
export const trackFormSubmit = (formName) => {
  trackConversion(CONVERSION_LABELS.FORM_SUBMIT, 10, {
    'form_name': formName
  });
};

// Track user signup
export const trackSignup = (userType = 'customer', userData = {}) => {
  const value = userType === 'usta' ? 200 : 100;
  const label = userType === 'usta' ? CONVERSION_LABELS.USTA_SIGNUP : CONVERSION_LABELS.SIGNUP;
  
  if (userData.phone) {
    trackEnhancedConversion(label, userData, value);
  } else {
    trackConversion(label, value, { 'user_type': userType });
  }
  
  trackRemarketingEvent('sign_up', { 'user_type': userType });
};

// Track service page view (for remarketing)
export const trackServicePageView = (serviceName, city = null) => {
  trackRemarketingEvent('view_item', {
    'items': [{
      'id': serviceName,
      'name': serviceName,
      'category': city ? `${city} ${serviceName}` : serviceName,
      'google_business_vertical': 'custom'
    }]
  });
};

// Page view tracker component
const GoogleAdsTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view on route change
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        'page_title': document.title,
        'page_location': window.location.href,
        'page_path': location.pathname
      });
    }
    
    // Push to dataLayer for GTM
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        'event': 'pageview',
        'page': location.pathname
      });
    }
    
    // Track remarketing for SEO/service pages
    if (location.pathname.includes('kombi-servisi')) {
      const city = location.pathname.includes('ankara') ? 'Ankara' : 
                   location.pathname.includes('istanbul') ? 'İstanbul' : 
                   location.pathname.includes('izmir') ? 'İzmir' : null;
      trackServicePageView('Kombi Servisi', city);
    }
  }, [location]);
  
  return null;
};

export default GoogleAdsTracker;
export { CONVERSION_LABELS };
